export const ROOT = "/admin/company";
